// extracted by mini-css-extract-plugin
export default {"parent":"modal_parent__5IDnB","parentTitle":"modal_parentTitle__ZTFVv","parentIcon":"modal_parentIcon__K8IF1","parentClose":"modal_parentClose__CaMdA"};